import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addDepartment = createAsyncThunk('addDepartment', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'department',
            data: {
                "department_name": data?.values?.departmentName,
                // "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
